var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfavoriteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7823 4.00546C10.6001 2.02899 13.3997 2.02898 14.2176 4.00546L15.6172 7.38797L19.1831 7.61802C21.3193 7.75584 22.22 10.4096 20.609 11.8192L19.1321 13.1115C18.7581 13.4388 18.1895 13.4009 17.8622 13.0268C17.5348 12.6527 17.5728 12.0842 17.9468 11.7568L19.4237 10.4646C19.8264 10.1122 19.6013 9.44874 19.0672 9.41429L14.942 9.14815C14.5996 9.12605 14.2995 8.91118 14.1683 8.59413L12.5543 4.69369C12.3499 4.19957 11.65 4.19957 11.4455 4.69369C11.2418 5.18595 10.7652 5.52893 10.2194 5.30308C9.67355 5.07722 9.5786 4.49772 9.7823 4.00546Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 18.5391L15.0222 20.2827C16.4779 21.1225 18.1707 20.2482 18.5482 18.821L19.9635 20.2364C20.315 20.5879 20.8849 20.5879 21.2363 20.2364C21.5878 19.8849 21.5878 19.3151 21.2363 18.9636L6.03633 3.76362C5.68486 3.41215 5.11501 3.41215 4.76354 3.76362C4.41207 4.11509 4.41207 4.68494 4.76354 5.03641L7.19191 7.46479L4.81677 7.61802C2.68057 7.75584 1.77987 10.4096 3.39088 11.8192L6.24721 14.3185L5.4453 17.6407C4.95044 19.6909 7.1508 21.3366 8.97764 20.2827L11.9999 18.5391ZM4.93266 9.41429C4.39861 9.44874 4.17344 10.1122 4.57619 10.4646L7.84259 13.3227C8.09468 13.5433 8.20341 13.8856 8.12481 14.2112L7.19505 18.0631C7.07133 18.5756 7.62143 18.987 8.07813 18.7236L11.5502 16.7204C11.8285 16.5599 12.1714 16.5599 12.4497 16.7204L15.9217 18.7236C16.3784 18.987 16.9285 18.5756 16.8048 18.0631L16.521 16.8871C16.5119 16.8494 16.5053 16.8116 16.5011 16.774L8.88634 9.15921L4.93266 9.41429Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfavoriteOutline);
export default __webpack_public_path__ + "static/media/unfavorite_outline.61f50daeaac2fd131ed8e7341932ab12.svg";
export { ForwardRef as ReactComponent };